import React, { useState } from "react";
import parse from "html-react-parser";
import Icon from "components/Elements/Icon/Icon.tsx";
import Button from "components/Elements/Button/Button.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useToasts } from "react-toast-notifications";

const EmbedConfirmMailModal = () => {
  const { getTextByKey, getLanguageCulture } = useContent();
  const [loading, setLoading] = useState(false);
  const { addToast } = useToasts();
  const { getUserData } = useUser();
  const userData = getUserData();
  const { closeModal } = useModal();
  //verification-email-embed-page-text
  const RegistrationResendConfirmationEmail = async () => {
    setLoading(true);
    const body = {
      UserCulture: getLanguageCulture(),
    };
    const response = await apiRequest(
      "Users",
      "RegistrationResendConfirmationEmail",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        addToast(getTextByKey("send-email-verify-success"), {
          appearance: "success",
        });
      } else {
        addToast(getTextByKey("send-email-verify-error"), {
          appearance: "error",
        });
      }
    } else {
      addToast(getTextByKey("send-email-verify-error"), {
        appearance: "error",
      });
    }
    setLoading(false);
    closeModal();
  };

  const replaceTextWithEmail = (text) => {
    const email = userData.UserName;
    return text.replace("#UserEmail#", email);
  };

  return (
    <div className="embed-confirm-modal">
      <div className="title">
        <div className="icon-image-div">
          <Icon name={"jform-black"} />
        </div>
        <span>JUMBOforms</span>
      </div>
      <div className="body-content">
        <div className="title"> {getTextByKey("verify-email-title")}</div>
        <div className="text">
          <p>
            {replaceTextWithEmail(
              getTextByKey("verification-email-embed-page-text")
            )}
          </p>
          {parse(getTextByKey("welcome-trial-text2"))}
        </div>
        <div className="text2">
          <Button
            className="new-button embed-button"
            onClick={() => RegistrationResendConfirmationEmail()}
          >
            {loading ? (
              <Image name="preloader" ext="gif" title="" text="" />
            ) : (
              getTextByKey("resend-email-button")
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmbedConfirmMailModal;
